import {
  API_ENDPOINT,
  useClientApiV1OrderSummariesQuery,
} from '../../resources/@types/courseSchema';
import useQueryOptionWithUserId from '../hooks/useQueryOptionWithUserId';

function useClientApiOrderSummariesQuery(
  options?: Parameters<typeof useClientApiV1OrderSummariesQuery>[0]['options'],
) {
  const { queryKey, url } = useQueryOptionWithUserId(API_ENDPOINT.CLIENT_V1_ORDER_SUMMARIES);

  return useClientApiV1OrderSummariesQuery({
    queryKey: queryKey,
    url: url,
    options,
  });
}

useClientApiOrderSummariesQuery.queryKey = [API_ENDPOINT.CLIENT_V1_ORDER_SUMMARIES];

export default useClientApiOrderSummariesQuery;
